'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Gallery = require('./Gallery.scss');

var _Gallery2 = _interopRequireDefault(_Gallery);

var _reactRedux = require('react-redux');

var _gallery = require('redux/modules/gallery');

var galleryActions = _interopRequireWildcard(_gallery);

var _lockscreen = require('redux/modules/lockscreen');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Gallery: {
    displayName: 'Gallery'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/Gallery/Gallery.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Gallery = _wrapComponent('Gallery')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isOpen: state.gallery.isOpen,
    activeIndex: state.gallery.activeIndex,
    items: state.gallery.items
  };
}, (0, _extends3.default)({}, galleryActions, { addId: _lockscreen.addId, removeId: _lockscreen.removeId })), _dec2 = (0, _reactCssModules2.default)(_Gallery2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Gallery, _Component);

  function Gallery() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Gallery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Gallery.__proto__ || (0, _getPrototypeOf2.default)(Gallery)).call.apply(_ref, [this].concat(args))), _this), _this.onPrev = function () {
      _this.props.prev();
    }, _this.onNext = function () {
      _this.props.next();
    }, _this.getThumbnails = function () {
      var _this$props = _this.props,
          activeIndex = _this$props.activeIndex,
          items = _this$props.items;

      var length = items.length;
      var limit = 7;
      var half = Math.floor(limit / 2);
      if (length < limit) {
        return items;
      }
      return _lodash2.default.fill(new Array(limit), '').map(function (num, index) {
        return items[(activeIndex + index - half + items.length) % items.length];
      });
    }, _this.handleKeyUp = function (event) {
      if (event.keyCode === 37) {
        _this.onPrev();
      } else if (event.keyCode === 39) {
        _this.onNext();
      } else if (event.keyCode === 27) {
        _this.close();
      }
    }, _this.close = function () {
      _this.props.openGallery(false);
    }, _this.innerClick = function (event) {
      event.stopPropagation();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Gallery, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.setItems(this.props.images, this.props.video);
      window.addEventListener('keyup', this.handleKeyUp);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      if (!_lodash2.default.isEqual(this.props.images, props.images)) {
        this.props.setItems(props.images, props.video);
      }
      if (this.props.isOpen === false && props.isOpen === true) {
        this.props.addId('gallery');
      } else if (this.props.isOpen === true && props.isOpen === false) {
        this.props.removeId('gallery');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.removeId('gallery');
      window.removeEventListener('keyup', this.handleKeyUp);
    }
  }, {
    key: 'onIndex',
    value: function onIndex(index) {
      this.props.goTo(index);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          activeIndex = _props.activeIndex,
          items = _props.items,
          defaultAlt = _props.defaultAlt;

      return _react3.default.createElement(
        'div',
        { styleName: this.props.isOpen ? 'gallery-open' : 'gallery', onClick: this.close },
        _react3.default.createElement(
          'div',
          { styleName: 'gallery-content', onClick: this.innerClick },
          _react3.default.createElement('a', { styleName: 'btn-close', onClick: this.close }),
          _react3.default.createElement(
            'div',
            { styleName: 'slide-show', style: items.length > activeIndex && !items[activeIndex].video ? items[activeIndex].style : null },
            _react3.default.createElement('div', { styleName: 'mobile-left-arrow', onClick: this.onPrev }),
            this.props.isOpen && items[activeIndex].video ? _react3.default.createElement(
              'div',
              { styleName: 'video-container' },
              _react3.default.createElement('iframe', { width: '1031', height: '580', src: items[activeIndex].video, frameBorder: '0', allowFullScreen: true })
            ) : _react3.default.createElement('img', { styleName: 'image', src: items.length > activeIndex && items[activeIndex].url, alt: defaultAlt, key: 'img-' + activeIndex }),
            _react3.default.createElement('div', { styleName: 'mobile-right-arrow', onClick: this.onNext })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'caption-container' },
            _react3.default.createElement(
              'p',
              { styleName: 'caption' },
              '(',
              activeIndex + 1,
              '/',
              items.length,
              ')'
            ),
            _react3.default.createElement(
              'p',
              { styleName: 'caption' },
              items.length > activeIndex && ' ' + items[activeIndex].caption
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'images-container' },
            this.getThumbnails().map(function (image, index) {
              return _react3.default.createElement(
                'div',
                { key: 'trip-image-' + index, styleName: 'thumbnail-container' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'thumbnail', onClick: _this2.onIndex.bind(_this2, image.index), style: image.thumbnailStyle },
                  image.index !== activeIndex && _react3.default.createElement('div', { styleName: 'shadow' }),
                  image.video && _react3.default.createElement('div', { styleName: 'play' })
                )
              );
            })
          )
        )
      );
    }
  }]);
  return Gallery;
}(_react2.Component), _class2.propTypes = {
  images: _react2.PropTypes.array,
  video: _react2.PropTypes.string,
  defaultAlt: _react2.PropTypes.string,
  items: _react2.PropTypes.array,
  isOpen: _react2.PropTypes.bool,
  activeIndex: _react2.PropTypes.number,
  openGallery: _react2.PropTypes.func,
  setItems: _react2.PropTypes.func,
  goTo: _react2.PropTypes.func,
  prev: _react2.PropTypes.func,
  next: _react2.PropTypes.func,
  addId: _react2.PropTypes.func,
  removeId: _react2.PropTypes.func
}, _class2.defaultProps = {
  images: [],
  video: ''
}, _temp2)) || _class) || _class));

exports.default = Gallery;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/General/Gallery/Gallery.js
// module id = 1526
// module chunks = 0